import styles from './ArchitectureExample.module.scss'
import { useRef } from 'react'
import Slider from 'react-slick'
import styled from 'styled-components'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

const ArchitectureExample: React.FC = () => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  const settings = {
    dots: true,
    infinite: true,
    fade: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  }

  const imagePaths = [
    '/img/services/matchsystem-constitution.png',
    '/img/services/finance-constitution.png',
    '/img/services/mass-constitution.png',
    '/img/services/healthcare-constitution.png',
  ]

  return (
    <section
      className={`${styles.line} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>アーキテクチャ構成例</h2>
        <p className={styles.sectionRead}>
          実際の導入事例に基づいた、当社が提案するアーキテクチャ構成の一例を紹介します
        </p>
        <SliderWrapper>
          <Slider {...settings}>
            {imagePaths.map((path, index) => (
              <div className={styles.img__container} key={index}>
                <img src={path} alt="アーキテクチャ構成例" />
              </div>
            ))}
          </Slider>
        </SliderWrapper>
      </div>
    </section>
  )
}

export default ArchitectureExample

const SliderWrapper = styled.div`
  .slick-dots {
    margin: 20px auto 0;
    position: relative;
    bottom: 0;
    text-align: left;
    @media (max-width: 1199px) {
      padding: 0 24px;
    }
    @media (min-width: 1200px) {
      padding: 0 130px;
      margin: 27px auto 0;
    }
  }

  .slick-dots li {
    width: 40px;
    height: 4px;
    background: #ccc;
    margin: 0 0 0 8px;
    @media (max-width: 719px) {
      width: 32px;
    }
  }

  .slick-dots li:first-child {
    margin: 0;
  }

  .slick-dots li.slick-active {
    background: #bf012d;
  }

  .slick-dots li button {
    width: 100%;
    height: 100%;
    padding: 0;
  }

  .slick-dots li button::before {
    content: none;
  }
  .slick-slide > div {
    height: 50%;
  }
`
